import {
  API_ERROR,
  LOCATIONS,
  LOCATION_LIST_SUCCESSFUL,
  LOCATION_ADD,
  LOCATION_ADD_SUCCESSFUL,
  LOCATION_EDIT,
  LOCATION_EDIT_SUCCESSFUL,
  LOCATION_DELETE,
  LOCATION_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  locationslist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const location = (state = initialState, action) => {
  switch (action.type) {
    case LOCATIONS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOCATION_LIST_SUCCESSFUL:
      state = {
        ...state,
        locationslist: action.payload.response.results,
        loading: false,
      };
      break;
    case LOCATION_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOCATION_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {Id:0},
      };
      break;
    case LOCATION_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: action.payload,
      };
      break;
    case LOCATION_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: {Id:0},
      };
      break;
    case LOCATION_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOCATION_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default location;
